import React, { useEffect, useState } from "react";
import AdminHeading from "../AdminPanel/Heading/AdminHeading";
import AdminBreadCrump from "../AdminPanel/Heading/AdminBreadCrump";
import "../PagesStyles/AdminMasters.css";
import { useRef } from "react";
import { TbCircleNumber1 } from "react-icons/tb";
import { Toaster, toast } from "react-hot-toast";
import {
  a100,
  a101,
  a104,
  a107,
  a108,
  a109,
  a110,
  a111,
  a112,
  a18,
  a35,
  a7,
  a707,
  a708,
  a709,
  a95,
  a96,
  a97,
  a98,
  a99,
} from "../../Api/RootApiPath";
import { useSelector } from "react-redux";
import { RiListUnordered, RiPlayListAddLine } from "react-icons/ri";
import AlertMessage from "../../Other Functions/AlertMessage";
import { allCountriesList } from "../../Api/CountriesAllList";
import { allStateList } from "../../Api/StateList";
import style from "./AddNewCustomer.module.css";
import { Icon } from "@iconify/react";
import style2 from "../../../Components/support/customervendor/Customer.module.css";
import Customertable from "Components/support/customervendor/customer";
import { Box } from "@mui/material";

export default function AddEmployeeNew() {
  const [active, setActive] = useState("AddNew");
  const [showError, setShowError] = useState(false);
  const [messageType, setMessageType] = useState("");
  const [messageToShow, setMessageToShow] = useState("");
  const [loading, setLoading] = useState(false);

  const [allCategories, setAllCategories] = useState([]);

  const handlenew = () => {
    setActive("AddNew");
  };
  const [newCategory, setNewCategory] = useState({
    CompCode: "",
    BranchCode: "",
    EmployeeCode: "",
    FirstName: "",
    LastName: "",
    EmpEmail: "",
    MobileNumber: "",
    Town: "",
    StreetAddress: "",
    City: "",
    State: "",
    Country: "India",
    AadharNo: "",
    PanNo: "",
    Counter: "",
    DateOfBirth: "",
    Gender: "",
    Designation: "",
    WorkLocation: "",
    Department: "",
    ReportingTo: "",
    BankName: "",
    AccountName: "",
    BankAccountNo: "",
    BranchName: "",
    IfscCode: "",
    JoiningDate: "",
    Salary: "",
    UserName: "",
    Password: "",
    SeatingLocation: "",
    FinancialYear: "",

    OldEntry: false,
  });
  const [allCompaniesList, setAllCompaniesList] = useState([]);
  const [allBranchesList, setAllBranchesList] = useState([]);
  const [allDepartmentsList, setAllDepartmentsList] = useState([]);
  const [allRolesList, setAllRolesList] = useState([]);
  const [allCountersList, setAllCountersList] = useState([]);
    const [searchInput, setSearchInput] = useState('');
  const allStates = useSelector((state) => state);
  const adminLoggedIn = allStates.reducer1;
  //   let Entryby_Staff_id = parseInt(adminLoggedIn);
  const clientCode = adminLoggedIn.ClientCode;


  const handleSearchChange = (event) => {
    setSearchInput(event.target.value);
  };

  useEffect(() => {
    window.scroll(0, 0);
  }, []);
  const fetchAllCategory = async () => {
    const formData = {
      ClientCode: clientCode,
    };
    const response = await fetch(a709, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();
    console.log(data, "data,");
    try {
      if (data.length > 0) {
        setAllCategories(data);
      } else {
        setActive("addNew");
        document
          .getElementById("addCategoryListTitle")
          .classList.add("activeCategoryTitle");
        document
          .getElementById("addCategoryListLogo")
          .classList.add("activeCategoryLogo");
        document.getElementById("addCategoryListTitle").click();
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchAllCategory();
  }, []);
  const fetchAllCompanies = async () => {
    const formData = {
      ClientCode: clientCode,
    };
    const response = await fetch(a95, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();
    console.log(data, "data,");
    try {
      if (data.length > 0) {
        setAllCompaniesList(data);
      } else {
        // alert("Please Add Company First");
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchAllCompanies();
  }, []);

  const fetchAllBranches = async () => {
    const formData = {
      ClientCode: clientCode,
    };
    const response = await fetch(a98, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();
    console.log(data, "data,");
    try {
      if (data.length > 0) {
        setAllBranchesList(data);
      } else {
        // alert("Please Add Company First");
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchAllBranches();
  }, []);

  const fetchAllDepartments = async () => {
    const formData = {
      ClientCode: clientCode,
    };
    const response = await fetch(a104, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();
    console.log(data, "data,");
    try {
      if (data.length > 0) {
        setAllDepartmentsList(data);
      } else {
        // alert("Please Add Company First");
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchAllDepartments();
  }, []);
  useEffect(() => {
    if (newCategory.Country === "India") {
      setCountryStates(states.IN);
    }
  }, []);

  const fetchAllRoles = async () => {
    const formData = {
      ClientCode: clientCode,
    };
    const response = await fetch(a107, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();
    console.log(data, "data,");
    try {
      if (data.length > 0) {
        setAllRolesList(data);
      } else {
        // alert("Please Add Company First");
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchAllRoles();
  }, []);

  const fetchAllCounters = async () => {
    const formData = {
      ClientCode: clientCode,
    };
    const response = await fetch(a101, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();
    console.log(data, "data,");
    try {
      if (data.length > 0) {
        setAllCountersList(data);
      } else {
        // alert("Please Add Company First");
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchAllCounters();
  }, []);
  console.log(allCategories, "allCategories");
  console.log(allCompaniesList, "allCompaniesList");
  console.log(allDepartmentsList, "allDepartmentsList");
  console.log(allBranchesList, "allBranchesList");
  console.log(allRolesList, "allRolesList");

  const states = {
    US: ["California", "Texas", "Florida", "New York"],
    IN: allStateList,
    // Add more states for each country as needed
  };

  const [countryStates, setCountryStates] = useState([]);
  const handleNewCategoryChange = (e) => {
    const { name, value } = e.target;

    console.log(name, value);
    
    // Update the edited data in the state
    setNewCategory({ ...newCategory, [name]: value });
    if (name == "Country" && value == "India") {
      setCountryStates(states.IN);
      setNewCategory({ ...newCategory, Country: value, State: "" });
    } else if (name == "Country" && value == "United States") {
      setCountryStates(states.US);
      setNewCategory({ ...newCategory, Country: value, State: "" });
    } else {
      setNewCategory({ ...newCategory, [name]: value });
      setCountryStates([]);
    }
    if (name == "BranchCode") {
      setNewCategory({
        ...newCategory,
        FinancialYear: allBranchesList.filter((x) => x.Id == parseInt(value))[0]
          ?.FinancialYear,
        BranchCode: value,
      });
    }
  };
  console.log(newCategory, "newCategory");
  console.log(newCategory, "newCategory");

  const addNewCategory = async (e) => {
    e.preventDefault();
    setLoading(true);
    const formData = {
      ClientCode: clientCode,
      CompCode: newCategory.CompCode,
      BranchCode: newCategory.BranchCode,
      EmployeeCode: newCategory.EmployeeCode,
      FirstName: newCategory.FirstName,
      LastName: newCategory.LastName,
      EmpEmail: newCategory.EmpEmail,
      MobileNumber: newCategory.MobileNumber,
      Town: newCategory.Town,
      StreetAddress: newCategory.StreetAddress,
      City: newCategory.City,
      State: newCategory.State,
      Country: newCategory.Country,
      AadharNo: newCategory.AadharNo,
      PanNo: newCategory.PanNo,
      Counter: newCategory.Counter,
      DateOfBirth: newCategory.DateOfBirth,
      Gender: newCategory.Gender,
      Designation: newCategory.Designation,
      WorkLocation: newCategory.WorkLocation,
      Department: newCategory.Department,
      ReportingTo: newCategory.ReportingTo,
      Counter: newCategory.Counter,
      BankName: newCategory.BankName,
      AccountName: newCategory.AccountName,
      BankAccountNo: newCategory.BankAccountNo,
      BranchName: newCategory.BranchName,
      IfscCode: newCategory.IfscCode,
      JoiningDate: newCategory.JoiningDate,
      Salary: newCategory.Salary,
      UserName: newCategory.UserName,
      Password: newCategory.Password,
      SeatingLocation: newCategory.SeatingLocation,
      FinancialYear: newCategory.FinancialYear,
      ...(newCategory.OldEntry ? { Id: newCategory.Id } : {}),
    };
    console.log(formData, "formData to send");

    try {
      const response = await fetch(
        !newCategory.OldEntry ? a707 : a708,
        // a96,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        }
      );
      
      const data = await response.json();
      fetchAllCategory();
      setActive("List");
      setNewCategory({
        CompCode: "",
        BranchCode: "",
        EmployeeCode: "",
        FirstName: "",
        LastName: "",
        EmpEmail: "",
        MobileNumber: "",
        Town: "",
        StreetAddress: "",
        City: "",
        State: "",
        Country: "",
        AadharNo: "",
        PanNo: "",
        DateOfBirth: "",
        Counter: "",
        Gender: "",
        Designation: "",
        WorkLocation: "",
        Department: "",
        ReportingTo: "",
        BankName: "",
        AccountName: "",
        BankAccountNo: "",
        BranchName: "",
        IfscCode: "",
        JoiningDate: "",
        Salary: "",
        UserName: "",
        Password: "",
        SeatingLocation: "",
        FinancialYear: "",
        OldEntry: false,
      });
      if (data.Message) {
        // alert(data.message);
        // setMessageType("error");
        toast.error(data.Message, {
          duration: 3000,
          position: "top-center",
        });
        // setShowError(true);
        setActive("AddNew");
      } else {
        // setMessageType("success");
        toast.success("Employee Add Successfully!",{
          duration: 3000,
          position: 'top-center'
        });
        // setShowError(true);
      }
      setLoading(false);
      console.log(data);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    setTimeout(() => {
      setShowError(false);
    }, 2000);
  }, [showError]);
  const handleEditData = (data) => {
    console.log(data, "data");
    // console.log(data, "data");
    // console.log(data, "data");
    setNewCategory({ ...data, OldEntry: true });
    setActive("AddNew");
  };


  const columns = [
    { key: "serialNumber", label: "S.No", type: "read", priority: 2 },
    { key: "LastName", label: "Employee Code", type: "read", priority: 1 },

    { key: "FirstName", label: "First Name", type: "read", priority: 3 },
    { key: "LastName", label: "Last Name", type: "read", priority: 4 },
    { key: "EmpEmail", label: "Emp Email", type: "read", priority: 5 },
    { key: "MobileNumber", label: "Mobile Number", type: "read", priority: 6 },

    {
      key: "Town",
      label: "Town",
      type: "read",
      priority: 7,
    },
    { key: "StreetAddress", label: "Street Address", type: "read", priority: 8 },
    { key: "City", label: "City", type: "read", priority: 9 },
    {
      key: "State",
      label: "State",
      type: "read",
      priority: 10,
    },
    {
      key: "Country",
      label: "Country",
      type: "read",
      priority: 11,
    },
    {
      key: "AdharNo",
      label: "Adhar No",
      type: "read",
      priority: 12,
    },
    {
      key: "PanNo",
      label: "Pan No",
      type: "read",
      priority: 13,
    },
    {
      key: "DateOfBirth",
      label: "Date Of Birth",
      type: "read",
      priority: 14,
    },
    {
      key: "Gender",
      label: "Gender",
      type: "read",
      priority: 15,
    },
    {
      key: "Designation",
      label: "Designation",
      type: "read",
      priority: 16,
    },
    {
      key: "WorkLocation",
      label: "Work Location",
      type: "read",
      priority: 17,
    },
    {
      key: "Department",
      label: "Department",
      type: "read",
      priority: 18,
    },
    {
      key: "ReportingTo",
      label: "Reporting To",
      type: "read",
      priority: 19,
    },
    {
      key: "BankName",
      label: "Bank Name",
      type: "read",
      priority: 20,
    },
    {
      key: "AccountName",
      label: "Account Name",
      type: "read",
      priority: 21,
    },
    {
      key: "BankAccountNo",
      label: "Bank Account No",
      type: "read",
      priority: 22,
    },
    {
      key: "Branch Name",
      label: "BranchName",
      type: "read",
      priority: 23,
    },
    {
      key: "IFSC Code",
      label: "IFSCCode",
      type: "read",
      priority: 24,
    },
    {
      key: "JoiningDate",
      label: "Joining Date",
      type: "read",
      priority: 25,
    },
    {
      key: "Salary",
      label: "Salary",
      type: "read",
      priority: 26,
    },
    {
      key: "SeatingLocation",
      label: "Seating Location",
      type: "read",
      priority: 27,
    },
    {
      key: "FinancialYear",
      label: "Financial Year",
      type: "read",
      priority: 28,
    },
  ];

  const handleList = () => {
    setActive("List");

    console.log("handleList is clicked");
  };


  const handleSearchSubmit = () => {
    // You can handle the search logic here
    console.log("Searching for:", searchTerm);
  };


   const inputRef1 = useRef(null);
    const inputRef2 = useRef(null);
    const inputRef3 = useRef(null);
    const inputRef4 = useRef(null);
    const inputRef5 = useRef(null);
    const inputRef6 = useRef(null);
    const inputRef7 = useRef(null);
    const inputRef8 = useRef(null);
    const inputRef9 = useRef(null);
    const inputRef10 = useRef(null);
    const inputRef11 = useRef(null);
    const inputRef12 = useRef(null);
    const inputRef13 = useRef(null);
    const inputRef14 = useRef(null);
    const inputRef15 = useRef(null);
    const inputRef16 = useRef(null);
    const inputRef17 = useRef(null);
    const inputRef18 = useRef(null);
    const inputRef19 = useRef(null);
    const inputRef20 = useRef(null);
    const inputRef21 = useRef(null);
    const inputRef22 = useRef(null);
    const inputRef23 = useRef(null);
    const inputRef24 = useRef(null);
    const inputRef25 = useRef(null);
    const inputRef26 = useRef(null);
    const inputRef27 = useRef(null);
    const inputRef28 = useRef(null);
    const inputRef29 = useRef(null);

   // Focus inputRef1 on component mount
   useEffect(() => {
     inputRef1.current?.focus();
   }, []);
   // Handler function to move focus on Enter key press
 
   const handleResetField = () => {
     // List of all input and select refs
     const allRefs = [
       inputRef1,
       inputRef2,
       inputRef3,
       inputRef4,
       inputRef5,
       inputRef6,
       inputRef7,
       inputRef8,
       inputRef9,
       inputRef10,
       inputRef11,
       inputRef12,
       inputRef13,
       inputRef14,
       inputRef15,
       inputRef16,
       inputRef17,
       inputRef18,
       inputRef19,
       inputRef20,
       inputRef21,
       inputRef22,
       inputRef23,
       inputRef24,
       inputRef25,
       inputRef26,
       inputRef27,
       inputRef28,
       inputRef29,
     ];
 
     // Loop through each ref and reset the value
     allRefs.forEach((ref) => {
       if (ref.current) {
         if (ref.current.tagName === "SELECT") {
           ref.current.selectedIndex = 0; // Reset <select> to the first option
         } else {
           ref.current.value = ""; // Clear input field
         }
       }
     });
 
     // Refocus on the first input after reset
     inputRef1.current?.focus();
   };
 
   const handleKeyPress = (e, nextInputRef) => {
     if (e.key === "Enter") {
       e.preventDefault(); // Prevent default form submission on Enter
       if (nextInputRef) {
         nextInputRef.current?.focus();
       } else {
         if (submitButtonRef.current) {
           submitButtonRef.current.click(); // Safely trigger click
         } else {
           console.error("Submit button ref is not available");
         }
       }
     }
   };

  return (
    <div>
      <AdminHeading />
      <div style={{ paddingTop: "130px" }} >
        {showError ? (
          <AlertMessage message={messageToShow} type={messageType} />
        ) : null}
        <AdminBreadCrump
          title={"Add Employees"}
          companyName={"Loyalstring"}
          module={"User Masters"}
          page={"Employees"}
        />
           </div>
  <div style={{ padding: "16px" }}>
        {active == "List" ? (
         <>
         <div className={style["white-space"]}>
               

               <div className={style["icon-div"]}>
                 <div className={style["search-container"]}>
                   <input
                     type="text"
                     value={searchInput}
                     onChange={handleSearchChange}
                     
                     placeholder="Search..."
                     className={style["serach-input"]}
                   />
                   <button
                     style={{ margin: 0 }}
                     className={style["search-btn"]}
                     onClick={handleSearchSubmit}
                   >
                     <Icon style={{ fontSize: "20px" }} icon="mdi:magnify" />
                   </button>
                 </div>
                 
                 <Icon
                 
                   style={{
                     fontSize: "28px ",
                     color: "#0077d4",
                     cursor: "pointer",
                   }}
                   icon="bx:export"
                 />
                 
                
                 <button
                   // style={{ width: "30%" }}
                   className={style["custom-btn"]}
                 >
                   <Icon
                     style={{ fontSize: "24px " }}
                     icon="ic:outline-print"
                   />
                   Print
                 </button>
                 <button onClick={handlenew} style={{ margin: 0 }} className={style["custom-btn"]}>
                 New
                 <Icon icon="mdi:plus" width="24" height="24" />
               </button>
               </div>
             </div>

            <Customertable
              columns={columns}
              allCategories={allCategories}
              handleEditData={handleEditData}
              searchInput={searchInput}
              setSearchInput={setSearchInput}
             
              // title={"All Customers"}
            />
         </>
        ) : (
          <div className={style.adminAddCategoryMainBox}>
          <div className={style.adminAddCategoryInnerBox}>
            <div className={style.adminCategoryAddCategoryMainBox}>
                <form style={{width: '100%'}} onSubmit={addNewCategory}>
                  <div
                    style={{
                      gridTemplateColumns: "repeat(4,2fr)",
                      columnGap: "30px",
                      margin: "0px 0px",
                      padding: "var(--Space-0, 0px) 24px",
                    }}
                    // className="adminCategoryAddCategoryInnerBox"
                  >
                  <h2
                      style={{ marginTop: "20px", marginBottom: "20px" }}
                      className={style.adminCategoryHeading}
                      id="adminInvoiceAddedCustomerEdit"
                    >
                    Personal Details
                  </h2>
                  <Box sx={{ width: "95%", margin: "0 auto" }}>
                    <div
                      style={{
                        gridTemplateColumns: "repeat(4,1fr)",
                        columnGap: "40px",
                        margin: "15px 0px",
                      }}
                      className="adminCategoryAddCategoryInnerBox"
                    >
                    <label>
                      First Name <sup>*</sup>
                    </label>
                    <input
                      name="FirstName"
                      value={newCategory.FirstName}
                      onChange={handleNewCategoryChange}
                      type="text"
                      required="required"
                      style={{ border: "1px solid #ccc" }}
                      className={style.AddCustomerInput}
                      ref={inputRef1}
                          onKeyDown={(e) => handleKeyPress(e, inputRef2)}
                    />
                    <label>Last Name</label>
                    <input
                      name="LastName"
                      value={newCategory.LastName}
                      onChange={handleNewCategoryChange}
                      type="text"
                      style={{ border: "1px solid #ccc" }}
                      className={style.AddCustomerInput}
                      ref={inputRef2}
                          onKeyDown={(e) => handleKeyPress(e, inputRef3)}
                    />
                    <label>Emp Email</label>
                    <input
                      name="EmpEmail"
                      value={newCategory.EmpEmail}
                      onChange={handleNewCategoryChange}
                      type="email"
                      style={{ border: "1px solid #ccc", width: '100%' }}
                      className={style.AddCustomerInput}
                      ref={inputRef3}
                          onKeyDown={(e) => handleKeyPress(e, inputRef4)}
                    />
                    {/* <label>Contact Number</label>
                    <input
                      name="MobileNumber"
                      value={newCategory.MobileNumber}
                      onChange={handleNewCategoryChange}
                      type="text"
                      style={{ border: "1px solid #ccc" }}
                      className={style.AddCustomerInput}
                    /> */}

                    <label>Contact Number</label>
                    <input
                      name="MobileNumber"
                      value={newCategory.MobileNumber}
                      onChange={(e) => {
                        // Allow only numeric values and limit to 10 digits
                        const filteredValue = e.target.value.replace(/[^0-9]/g, "").slice(0, 10);
                        handleNewCategoryChange({ target: { name: "MobileNumber", value: filteredValue } });
                      }}
                      type="text"
                      style={{ border: "1px solid #ccc" }}
                      className={style.AddCustomerInput}
                      ref={inputRef4}
                          onKeyDown={(e) => handleKeyPress(e, inputRef5)}
                    />

                    <label>Street Address</label>
                    <input
                      name="StreetAddress"
                      value={newCategory.StreetAddress}
                      onChange={handleNewCategoryChange}
                      type="text"
                      style={{ border: "1px solid #ccc" }}
                      className={style.AddCustomerInput}
                      ref={inputRef5}
                          onKeyDown={(e) => handleKeyPress(e, inputRef6)}
                    />
                    <label>Town</label>
                    <input
                      name="Town"
                      value={newCategory.Town}
                      onChange={handleNewCategoryChange}
                      type="text"
                      style={{ border: "1px solid #ccc" }}
                      className={style.AddCustomerInput}
                      ref={inputRef6}
                          onKeyDown={(e) => handleKeyPress(e, inputRef7)}
                    />

                    <label>
                      Country <sup>*</sup>
                    </label>

                    <select
                      name="Country"
                      value={newCategory.Country}
                      onChange={handleNewCategoryChange}
                      required="required"
                      style={{ border: "1px solid #ccc" }}
                      className={style.AddCustomerSelect}
                      ref={inputRef7}
                          onKeyDown={(e) => handleKeyPress(e, inputRef8)}
                    >
                      {allCountriesList.map((x, y) => (
                        <option key={y} value={x}>
                          {x}
                        </option>
                      ))}
                    </select>
                    <label>
                      State <sup>*</sup>
                    </label>
                    <input
                      name="State"
                      value={newCategory.State}
                      onChange={handleNewCategoryChange}
                      type="text"
                      required="required"
                      list="statesList"
                      style={{ border: "1px solid #ccc" }}
                      className={style.AddCustomerInput}
                      ref={inputRef8}
                          onKeyDown={(e) => handleKeyPress(e, inputRef9)}
                    />
                    <datalist id="statesList">
                      {countryStates.map((x, index) => (
                        <option key={index} value={x}>
                          {x}
                        </option>
                      ))}
                    </datalist>
                    <label>City</label>
                    <input
                      name="City"
                      value={newCategory.City}
                      onChange={handleNewCategoryChange}
                      type="text"
                      style={{ border: "1px solid #ccc" }}
                      className={style.AddCustomerInput}
                      ref={inputRef9}
                          onKeyDown={(e) => handleKeyPress(e, inputRef10)}
                    />
                    {/* <label>Aadhar No</label>
                    <input
                      name="AadharNo"
                      value={newCategory.AadharNo}
                      onChange={handleNewCategoryChange}
                      type="text"
                      style={{ border: "1px solid #ccc" }}
                      className={style.AddCustomerInput}
                    /> */}

                  <label>Aadhar No</label>
                  <input
                    name="AadharNo"
                    value={newCategory.AadharNo}
                    onChange={(e) => {
                      // Allow only numeric values and limit to 12 digits
                      const filteredValue = e.target.value.replace(/[^0-9]/g, "").slice(0, 12);
                      handleNewCategoryChange({ target: { name: "AadharNo", value: filteredValue } });
                    }}
                    type="text"
                    style={{ border: "1px solid #ccc" }}
                    className={style.AddCustomerInput}
                    ref={inputRef10}
                          onKeyDown={(e) => handleKeyPress(e, inputRef11)}
                  />

                    {/* <label>Pan No</label>
                    <input
                      name="PanNo"
                      value={newCategory.PanNo}
                      onChange={handleNewCategoryChange}
                      type="text"
                      style={{ border: "1px solid #ccc" }}
                      className={style.AddCustomerInput}
                    /> */}

                  <label>PAN No</label>
                  <input
                  ref={inputRef11}
                  onKeyDown={(e) => handleKeyPress(e, inputRef12)}
                    name="PanNo"
                    value={newCategory.PanNo}
                    onChange={(e) => {
                      // Allow only uppercase alphabets and digits, limit to 10 characters
                      const filteredValue = e.target.value
                        .toUpperCase() // Convert to uppercase
                        .replace(/[^A-Z0-9]/g, "") // Remove non-alphanumeric characters
                        .slice(0, 10); // Limit to 10 characters
                      handleNewCategoryChange({ target: { name: "PanNo", value: filteredValue } });
                      
                    }}
                    type="text"
                    style={{ border: "1px solid #ccc" }}
                    className={style.AddCustomerInput}
                  />

                    <label>Joining Date</label>
                    <input
                    ref={inputRef12}
                    onKeyDown={(e) => handleKeyPress(e, inputRef13)}
                      name="JoiningDate"
                      value={newCategory.JoiningDate}
                      onChange={handleNewCategoryChange}
                      type="date"
                      style={{ border: "1px solid #ccc", width: '100%' }}
                      className={style.AddCustomerInput}
                    />
                    <label>Date Of Birth</label>
                    <input
                    ref={inputRef13}
                    onKeyDown={(e) => handleKeyPress(e, inputRef14)}
                      name="DateOfBirth"
                      value={newCategory.DateOfBirth}
                      onChange={handleNewCategoryChange}
                      type="date"
                      style={{ border: "1px solid #ccc" , width: '100%'}}
                      className={style.AddCustomerInput}
                    />
                    <label>
                      Gender <sup>*</sup>
                    </label>
                    <select
                    ref={inputRef14}
                    onKeyDown={(e) => handleKeyPress(e, inputRef15)}
                      name="Gender"
                      value={newCategory.Gender}
                      onChange={handleNewCategoryChange}
                      required="required"
                      style={{ border: "1px solid #ccc" }}
                      className={style.AddCustomerSelect}
                    >
                      <option value={""}>Select An Option</option>
                      <option value={"Male"}>Male</option>
                      <option value={"Female"}>Female</option>
                    </select>
                    <label>Work Location</label>
                    <input
                    ref={inputRef15}
                    onKeyDown={(e) => handleKeyPress(e, inputRef16)}
                      name="WorkLocation"
                      value={newCategory.WorkLocation}
                      onChange={handleNewCategoryChange}
                      type="text"
                      style={{ border: "1px solid #ccc" }}
                      className={style.AddCustomerInput}
                    />

                    <label>Salary</label>
                    <input
                    ref={inputRef16}
                    onKeyDown={(e) => handleKeyPress(e, inputRef17)}
                      name="Salary"
                      value={newCategory.Salary}
                      onChange={handleNewCategoryChange}
                      type="number"
                      style={{ border: "1px solid #ccc" }}
                      className={style.AddCustomerInput}
                    />
                  </div>
                  </Box>
                  <h2
                      style={{ marginTop: "20px", marginBottom: "20px" }}
                      id="adminInvoiceAddedCustomerEdit"
                      className={style.adminCategoryHeading}
                    >
                    System Details
                  </h2>
                  <Box sx={{ width: "95%", margin: "0 auto" }}>

                  <div
                    style={{
                      gridTemplateColumns: "repeat(4,1fr)",
                      columnGap: "40px",
                    }}
                    className="adminCategoryAddCategoryInnerBox"
                  >
                    <label>
                      Company <sup>*</sup>
                    </label>
                    <select
                    ref={inputRef17}
                    onKeyDown={(e) => handleKeyPress(e, inputRef18)}
                      name="CompCode"
                      value={newCategory.CompCode}
                      onChange={handleNewCategoryChange}
                      type="text"
                      required="required"
                      style={{ border: "1px solid #ccc" }}
                      className={style.AddCustomerSelect}
                    >
                      <option value={""}>Select an option</option>;
                      {allCompaniesList.map((x) => {
                        return (
                          <>
                            <option value={x.Id}>{x.CompName}</option>;
                          </>
                        );
                      })}
                    </select>
                    <label>
                      Branch <sup>*</sup>
                    </label>
                    <select
                    ref={inputRef18}
                    onKeyDown={(e) => handleKeyPress(e, inputRef19)}
                      name="BranchCode"
                      value={newCategory.BranchCode}
                      onChange={handleNewCategoryChange}
                      type="text"
                      required="required"
                      style={{ border: "1px solid #ccc" }}
                      className={style.AddCustomerSelect}
                    >
                      <option value={""}>Select an option</option>;
                      {allBranchesList.map((x) => {
                        return (
                          <>
                            <option value={x.Id}>{x.BranchName}</option>;
                          </>
                        );
                      })}
                    </select>
                    <label>
                      Department <sup>*</sup>
                    </label>
                    <select
                    ref={inputRef19}
                    onKeyDown={(e) => handleKeyPress(e, inputRef20)}
                      name="Department"
                      value={newCategory.Department}
                      onChange={handleNewCategoryChange}
                      type="text"
                      required="required"
                      style={{ border: "1px solid #ccc" }}
                      className={style.AddCustomerSelect}
                    >
                      <option value={""}>Select an option</option>;
                      {allDepartmentsList.map((x) => {
                        return (
                          <>
                            <option value={x.DeptName}>{x.DeptName}</option>;
                          </>
                        );
                      })}
                    </select>
                    <label>Counter </label>
                    {/* <input
                    name="SeatingLocation"
                    value={newCategory.SeatingLocation}
                    onChange={handleNewCategoryChange}
                    type="text"
                  /> */}
                    <select
                    ref={inputRef20}
                    onKeyDown={(e) => handleKeyPress(e, inputRef21)}
                      name="Counter"
                      value={newCategory.Counter}
                      onChange={handleNewCategoryChange}
                      type="text"
                      style={{ border: "1px solid #ccc" }}
                      className={style.AddCustomerSelect}
                    >
                      <option value={""}>Select an option</option>;
                      {allCountersList.map((x) => {
                        return (
                          <>
                            <option value={x.Id}>{x.CounterName}</option>;
                          </>
                        );
                      })}
                    </select>
                    <label>
                      Roles <sup>*</sup>
                    </label>
                    <select
                    ref={inputRef21}
                    onKeyDown={(e) => handleKeyPress(e, inputRef22)}
                      name="Designation"
                      value={newCategory.Designation}
                      onChange={handleNewCategoryChange}
                      type="text"
                      required="required"
                      style={{ border: "1px solid #ccc" }}
                      className={style.AddCustomerSelect}
                    >
                      <option value={""}>Select an option</option>;
                      {/*<option value={"Director"}>Director</option>;*/}
                      {/*<option value={"Company Head"}>Company Head</option>;*/}
                      {/*<option value={"Branch Head"}>Branch Head</option>;*/}
                      {/*<option value={"Manager"}>Manager</option>;*/}
                      {/*<option value={"Accountant"}>Accountant</option>;*/}
                      {/*<option value={"Floor Manager"}>Floor Manager</option>*/}
                      {/*<option value={"Team Lead"}>Team Lead</option>;*/}
                      {/*<option value={"Salesman"}>Salesman</option>;*/}
                      {/*<option value={"Cashier"}>Cashier</option>;*/}
                      {/*<option value={"Other User"}>Other User</option>;*/}
                      {allRolesList.map((x) => {
                        return (
                          <>
                            <option value={x.Role}>{x.Role}</option>;
                          </>
                        );
                      })}
                    </select>
                    <label>Reporting To </label>
                    {/* <input
                    name="ReportingTo"
                    value={newCategory.ReportingTo}
                    onChange={handleNewCategoryChange}
                    type="text"
                  /> */}
                    <select
                    ref={inputRef22}
                    onKeyDown={(e) => handleKeyPress(e, inputRef23)}
                      name="ReportingTo"
                      value={newCategory.ReportingTo}
                      onChange={handleNewCategoryChange}
                      type="text"
                      style={{ border: "1px solid #ccc" }}
                      className={style.AddCustomerSelect}
                    >
                      <option value={""}>Select an option</option>;
                      {allCategories.map((x) => {
                        return (
                          <>
                            <option
                              value={`${x.FirstName} ${x.LastName}`}
                            >{`${x.FirstName} ${x.LastName}`}</option>
                          </>
                        );
                      })}
                    </select>
                    <label>
                      User Name<sup>*</sup>
                    </label>
                    <input
                      name="UserName"
                      value={newCategory.UserName}
                      onChange={handleNewCategoryChange}
                      type="text"
                      required="required"
                      style={{
                        border: "1px solid #ccc",
                        backgroundColor: "#fff",
                      }}
                      className={style.AddCustomerInput}
                    />
                    <label>
                      Password<sup>*</sup>
                    </label>
                    <input
                    ref={inputRef23}
                    onKeyDown={(e) => handleKeyPress(e, inputRef24)}
                      name="Password"
                      value={newCategory.Password}
                      onChange={handleNewCategoryChange}
                      type="password"
                      required="required"
                      style={{
                        border: "1px solid #ccc",
                        backgroundColor: "#fff",
                        width: "100%",
                      }}
                      className={style.AddCustomerInput}
                    />
                  </div>
                  </Box>
                  <h2
                      style={{ marginTop: "20px", marginBottom: "20px" }}
                      id="adminInvoiceAddedCustomerEdit"
                      // className="adminInvoiceAddTitles"
                      className={style.adminCategoryHeading}
                    >
                    Bank Details
                  </h2>
                  <Box sx={{ width: "95%", margin: "0 auto" }}>

                  <div
                    style={{
                      gridTemplateColumns: "repeat(4,1fr)",
                      columnGap: "40px",
                    }}
                    className="adminCategoryAddCategoryInnerBox"
                  >
                    <label>Bank Name</label>
                    <input
                    ref={inputRef24}
                    onKeyDown={(e) => handleKeyPress(e, inputRef25)}
                      name="BankName"
                      value={newCategory.BankName}
                      onChange={handleNewCategoryChange}
                      type="text"
                      style={{ border: "1px solid #ccc" }}
                      className={style.AddCustomerInput}
                    />
                    <label>Account Name</label>
                    <input
                    ref={inputRef25}
                    onKeyDown={(e) => handleKeyPress(e, inputRef26)}
                      name="AccountName"
                      value={newCategory.AccountName}
                      onChange={handleNewCategoryChange}
                      type="text"
                      style={{ border: "1px solid #ccc" }}
                      className={style.AddCustomerInput}
                    />
                    <label>Bank Account No</label>
                    <input
                    ref={inputRef26}
                    onKeyDown={(e) => handleKeyPress(e, inputRef27)}
                      name="BankAccountNo"
                      value={newCategory.BankAccountNo}
                      onChange={handleNewCategoryChange}
                      type="number"
                      style={{ border: "1px solid #ccc" }}
                      className={style.AddCustomerInput}
                    />
                    <label>Branch Name</label>
                    <input
                    ref={inputRef27}
                    onKeyDown={(e) => handleKeyPress(e, inputRef28)}
                      name="BranchName"
                      value={newCategory.BranchName}
                      onChange={handleNewCategoryChange}
                      type="text"
                      style={{ border: "1px solid #ccc" }}
                      className={style.AddCustomerInput}
                    />
                    {/* <label>IFSC Code</label>
                    <input
                      name="IfscCode"
                      value={newCategory.IfscCode}
                      onChange={handleNewCategoryChange}
                      type="text"
                      style={{ border: "1px solid #ccc" }}
                      className={style.AddCustomerInput}
                    /> */}

                  <label>IFSC Code</label>
                  <input
                  ref={inputRef28}
                  onKeyDown={(e) => handleKeyPress(e, null)}
                    name="IfscCode"
                    value={newCategory.IfscCode}
                    onChange={(e) => {
                      // Convert input to uppercase
                      const upperCaseValue = e.target.value.toUpperCase();
                      handleNewCategoryChange({ target: { name: "IfscCode", value: upperCaseValue } });
                    }}
                    type="text"
                    style={{ border: "1px solid #ccc" }}
                    className={style.AddCustomerInput}
                  />

                 

                   

                    {/*<label>Financial Year</label>*/}
                    {/*<input*/}
                    {/*  style={{ cursor: "not-allowed" }}*/}
                    {/*  name="FinancialYear"*/}
                    {/*  placeholder={newCategory.FinancialYear}*/}
                    {/*  // value={newCategory.FinancialYear}*/}
                    {/*  // onChange={handleNewCategoryChange}*/}
                    {/*  readOnly*/}
                    {/*  type="text"*/}
                    {/*/>*/}
                  </div>

                  </Box>

                  </div>
                  
                  {!loading ? (
                    <div className={style["btn-container"]}>
                      <button className={style.buttons} type="submit">
                        <Icon icon="ic:baseline-check" width="24" height="24" />
                        Submit
                      </button>
                      <button
                          className={style.buttons}
                          style={{
                            backgroundColor: "#fff",
                            color: "#0077d4",
                            border: "1px solid #0077d4",
                          }}
                          type="button"
                          onClick={handleResetField}
                        >
                          <Icon
                            style={{ color: "#0077d4" }}
                            icon="ix:reset"
                            width="24"
                            height="24"
                          />
                          Reset
                        </button>
                      <button
                        onClick={handleList}
                        className={style.buttons}
                        type="button"
                      >
                        <Icon
                          icon="fluent:list-rtl-16-filled"
                          width="24"
                          height="24"
                        />
                        List
                      </button>
                    </div>
                  ) : null}


                </form>
              </div>
            </div>
          </div>
        )}
        </div>
   
    </div>
  );
}
